import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

type NavItem = {
    label: string;
    path: string;
    icon?: IconDefinition;
};

type NavGroup = {
    title: string;
    options: NavItem[];
};

type SideBarOptionsProps = {
    options: NavGroup[];
    /** Called when a nav item is tapped — used to close the mobile drawer. */
    onNavigate?: () => void;
};

const BASE_STYLE =
    "p-2 rounded-md w-full flex items-center gap-2.5 transition-colors text-sm";

const SideBarOptions: React.FC<SideBarOptionsProps> = ({ options, onNavigate }) => {
    return (
        <div className="px-2 flex flex-col gap-1">
            {options.map((group, gi) => (
                <div key={gi} className="mb-1">
                    {group.title && (
                        <p className="text-xs font-semibold text-content-3 uppercase tracking-wider px-2 mt-3 mb-1">
                            {group.title}
                        </p>
                    )}
                    <div className="flex flex-col gap-0.5">
                        {group.options.map((option, i) => (
                            <NavLink
                                key={i}
                                to={option.path}
                                onClick={onNavigate}
                                className={({ isActive }) =>
                                    isActive
                                        ? `${BASE_STYLE} bg-slate-800 text-white`
                                        : `${BASE_STYLE} text-content-2 hover:bg-surface-muted`
                                }
                            >
                                {option.icon && (
                                    <FontAwesomeIcon
                                        icon={option.icon}
                                        className="w-4 h-4 flex-shrink-0"
                                    />
                                )}
                                <span>{option.label}</span>
                            </NavLink>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SideBarOptions;
